import React from 'react';
import { Search, ChevronDown } from 'lucide-react';

const SearchBar = ({
  searchQuery,
  setSearchQuery,
  handleSearch,
  suggestions,
  handleSuggestionClick
}) => {
  return (
    <div
      className="bg-[#fffbf0] rounded-xl shadow-lg p-6 mb-8 border-4 border-[#8b4513]"
      style={{ boxShadow: '8px 8px 0px rgba(139, 69, 19, 0.2)' }}
    >
      <form onSubmit={handleSearch} className="max-w-3xl mx-auto">
        <div className="flex flex-col md:flex-row gap-4">
          <div className="relative flex-1">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-[#8b4513]" />
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search for a historical figure or dynasty..."
              className="w-full pl-10 pr-4 py-3 border-2 border-[#8b4513] rounded-lg bg-[#fff8e7] focus:ring-2 focus:ring-[#8b4513] focus:border-[#8b4513] font-serif placeholder-[#8b4513]/60"
            />
          </div>
          <button
            type="submit"
            className="px-6 py-3 bg-[#8b4513] text-white rounded-lg hover:bg-[#6d3610] transition duration-200 flex items-center justify-center gap-2"
            style={{ boxShadow: '3px 3px 0px rgba(139, 69, 19, 0.2)' }}
          >
            <ChevronDown className="h-5 w-5" />
            Show Family Tree
          </button>
        </div>

        <div className="mt-6">
          <h3 className="text-sm font-semibold text-[#8b4513] uppercase tracking-wider mb-3">
            Notable Dynasties
          </h3>
          <div className="flex flex-wrap gap-2">
            {suggestions.map((suggestion) => (
              <button
                key={suggestion}
                type="button"
                onClick={() => handleSuggestionClick(suggestion)}
                className="px-4 py-2 rounded-lg text-sm font-medium bg-[#fff8e7] text-[#8b4513] hover:bg-[#ffe4b5] border-2 border-[#8b4513] transition-colors duration-200"
                style={{ boxShadow: '2px 2px 0px rgba(139, 69, 19, 0.2)' }}
              >
                {suggestion}
              </button>
            ))}
          </div>
        </div>
      </form>
    </div>
  );
};

export default SearchBar;
